export default __webpack_public_path__ + "static/media/passport-example.8774a9d6.png";